import baseApi from '../utils/ApiUtils';

export const catalogueApi= (method, payload = null, params = null) => {
  return baseApi(`/catalogues/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const catalogueAction= (method, id, payload = null, params = null) => {
  return baseApi(`/catalogues/${id}/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const catalogueTransition= (method, id, payload = null, params = null) => {
  return baseApi(`/catalogues/${id}/transition/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const catalogueTaskPoolService= (method, id, payload = null, params = null) => {
  return baseApi(`/catalogues/${id}/task_pools/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const catalogueReportApi = (method, params = null, payload = null) => {
  return baseApi(`/reports/catalogues/?format=csv`, method, params, payload, 'blob').then(response => {
    return response.data;
  });
};


